
import { Cos } from './cos'

class WorkOrder {
    #COS;
    constructor() {
        this.#COS = new Cos({
            prefix: '/gz/Vivo/*',
            path: '/gz/Vivo/Attachment2222',
            type: 'Vivo'
        })
    }
    async putObject(file, options) {
        return await this.#COS.putObject(file, options)
    }
    getBasePrefix() {
        return this.#COS.basePrefix;
    }
    cancelTask(id) {
        return this.#COS.cancelTask(id)
    }
}

export default new WorkOrder();